import { OrganisationTypeConstants } from "../../../../../../constants";
import { AssetManagerSingleCardTemplate, DeveloperSingleCardTemplate } from "../../../../../../templates";
import { useAuth } from "../../../../../../useAuth";
import { InviteForm } from "./form";
import { useInvite } from "./useInvite";

export const Invite = (): JSX.Element => {
  const { currentUserType } = useAuth();
  const { pageTitle, handleBackClick } = useInvite();
  const isAssetManager = currentUserType === OrganisationTypeConstants.ASSET_MANAGER;
  // The heading and the explanatory box belong to ProjectAccessInviteFields, the same way the
  // details page leaves them to ProjectAccessEditFields.
  const content = <InviteForm />;

  return isAssetManager ? (
    <AssetManagerSingleCardTemplate
      pageTitle={pageTitle}
      handleBackClick={handleBackClick}
      backButtonText="Back to full project"
      activeElement="Projects"
    >
      {content}
    </AssetManagerSingleCardTemplate>
  ) : (
    <DeveloperSingleCardTemplate
      pageTitle={pageTitle}
      handleBackClick={handleBackClick}
      backButtonText="Back to full project"
    >
      {content}
    </DeveloperSingleCardTemplate>
  );
};
